// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"243":"3d1da320","788":"bb556e57"}[chunkId] + ".css";
};